module.exports = __webpack_public_path__ + "assets/view_2d.1aefd582.svg";